import axios from 'axios';
import { API_URLS } from './config';

interface CorrectionResponse {
  correction: {
    corrected_text: string;
  };
  status: string;
}

export const getCorrection = async (text: string, language: string): Promise<CorrectionResponse> => {
  console.log('Calling correction API with:', { text, language });
  
  try {
    const { data } = await axios.post<CorrectionResponse>(API_URLS.correction, {
      text,
      language,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('Correction API response:', data);
    return data;
  } catch (error) {
    console.error('Error getting correction:', error);
    throw error;
  }
};
